import Grid from '@mui/material/Grid';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {useNavigate, useLocation} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { HouseboatOutlined } from "@mui/icons-material";
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Divider from '@mui/material/Divider';
import Step1 from "./step1";
import MenuIcon from '@mui/icons-material/Menu';





const Mastertemplate = props => {

  const passed = useLocation();

    
  ///////Variable to Pass On to Contract Generator machine//////////
  const [sellerData,setSellerData] = useState([
    {namaPerusahaan:"PT. Supardi Nethanel Husain", alamat:"", nomorTelepon:""},
]);
const [currentStep,setCurrentStep] = useState(1)

const [progressTracker, setProgressTracker] = useState(0)

const [selectedPost, setSelectedPost] = useState(null);

useEffect(()=>{
})

/////End Variable to Pass on to contract generator machine////////

///////Functions for Seller Company///////////////////////////////
const handleSellerCompany = (event) => {
    console.log(event)
    const values =[...sellerData];
    values.namaPerusahaan = event.target.value;
    setSellerData(values)
};
///////End of Functions for Seller Company///////////////////////////////
///////Progress Bar Function/////////////////////////////////////////////
    function LinearProgressWithLabel(props) {
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
              <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography variant="body2" color="text.secondary">{`${Math.round(
                props.value,
              )}%`}</Typography>
            </Box>
          </Box>
        );
      }
///////End of Progress Bar Function////////////////////////////////////
//////Prev, Next, Submit Button Functions/////////////////////////////

function nextButton(post){
  if (currentStep !== 5) {
    setProgressTracker(((currentStep)/5)*100)
    setCurrentStep(currentStep+1)
    console.log(post)
    setSelectedPost(post);
  }else{}
}
const [statusEdit, setStatusEdit] = useState("Pembuatan Kontrak");
const [selectedType, setSelectedType] = useState();
const [klienID, setklienID] = useState(null);
const [companyID, setcompanyID] = useState(null)
function prevButton(){
  if (currentStep !== 1) {
    setProgressTracker(((currentStep-2)/5)*100)
    setCurrentStep(currentStep-1)
  }else{}
}
////////End Prev,Next, Submit Button Functions//////////////////////
//////////Start Date Picker Function////////////////////////////////
const [bDate,setbDate] = useState(Date())
const handleDateChange = (event) => {
  setbDate(event);
  console.log(event)
}
//////////Start Date Picker Function////////////////////////////////


    return ( <>            

          <Step1 sellerData={sellerData} nextButton={nextButton} currentStep={currentStep} companyID={companyID} handleSellerCompany={handleSellerCompany} setklienID={setklienID} setcompanyID={setcompanyID}></Step1>


  </>
  );
};
export default Mastertemplate;
